import { useQuery } from '@tanstack/react-query';
import { edupassClient } from '@/data/@clients';
import { clientKeys } from '@/data/@clients/client-keys';
import type { User } from '@/models/user';

export const useUser = (enabled = true) => {
  const response = useQuery<{ data: User }>({
    queryKey: [clientKeys.useUser],
    queryFn: () => edupassClient.get('/user'),
    enabled,
  });

  return { user: response?.data?.data, ...response };
};
